@if ((data$ | async); as data) {
<tux-page-header
  [pageTitle]="'Adex - ' + data.instance?.name"
  [breadcrumbs]="[
    { path: '', title: 'Home' },
    { path: '/application-manager', title: 'Current Customers' },
    {
      path: '/application-manager/' + data.customer?.customerId,
      title: data.customer?.name || 'Customer'
    },
    { title: 'Adex Instance' }
  ]"
  [subMenu]="false"
>
  <tux-page-header-buttons>
    <p-button
      label="Decommission"
      [outlined]="true"
      [severity]="'danger'"
      styleClass="surface-border font-medium"
      [disabled]="data.instance"
      (click)="data.instance && decommissionInstance(data.instance)"
    ></p-button>
    <p-button
      type="primary"
      label="Change Status"
      styleClass="font-medium"
      (click)="changeInstanceStatus()"
    ></p-button>
  </tux-page-header-buttons>

  <div ngProjectAs="tux-metadata">
    <div class="flex gap-4 w-full">
      <div class="flex gap-2">
        <span class="font-medium">Marketer UUID</span>
        <span>{{ data.marketer?.uuid }}</span>
      </div>
    </div>
  </div>
</tux-page-header>

<!-- CPM (Demand Science Limited View) -->
<p-panel [toggleable]="true" class="block panel-padding w-8 pb-4">
  <ng-template pTemplate="header">
    <div class="flex align-items-center justify-content-between w-full">
      <label class="font-bold w-full" for="cpm-switch">
        Managed Services Customer
      </label>
      <p-toggleSwitch
        inputId="cpm-switch"
        [formControl]="marketerConfigs.controls.demand_science_cpm"
      ></p-toggleSwitch>
    </div>
  </ng-template>

  <div class="flex flex-column gap-1">
    <div>
      <p>
        This setting indicates that the customer is a managed ads customer and
        will have a limited view of the ABM platform.
        <a
          href="https://support.demandscience.com/hc/en-us/articles/38505062376211-Limited-View-for-Managed-Ads-Customers"
          target="_blank"
          >Click here to learn more about Limited View</a
        >
      </p>
    </div>
    <div class="flex justify-content-end">
      <p-button
        [disabled]="marketerConfigs.controls.demand_science_cpm.pristine"
        styleClass="p-2"
        label="Save Changes"
        (onClick)="
          updateDemandScienceCPM({
            marketerUuid: data.marketer?.uuid || '',
            demand_science_cpm:
              marketerConfigs.controls.demand_science_cpm.value
          })
        "
      ></p-button>
    </div>
  </div>
</p-panel>

<ng-container *ngFor="let config of configs">
  <p-panel
    [toggleable]="true"
    [style.padding]="'0 24px'"
    class="block panel-padding w-8 pb-4"
  >
    <ng-template pTemplate="header">
      <div class="flex align-items-center justify-content-between w-full">
        <label class="font-bold w-full" for="cpm-switch">
          {{ config.configKind.displayName }}
        </label>
      </div>
    </ng-template>

    <div class="flex flex-column gap-1">
      <div>
        <p class="pb-2">
          {{ config.configKind.description }}
        </p>
      </div>
      <div class="flex justify-content-start">
        <ng-container [ngSwitch]="config.configKind.type">
          <input
            *ngSwitchCase="'STRING'"
            [formControl]="config.fc"
            pInputText
            type="text"
            pSize="large"
            class="w-9"
          />
          <p-inputNumber
            *ngSwitchCase="'INT'"
            [formControl]="config.fc"
            class="w-9"
          />
          <p-toggleSwitch
            *ngSwitchCase="'BOOLEAN'"
            [formControl]="config.fc"
          ></p-toggleSwitch>
          <ng-container *ngSwitchCase="'MAP'">
            <div class="flex flex-column">
              <p class="pb-2">ID</p>
              <input [formControl]="contextualListId" pInputText class="pb-2" />
              <p class="py-2">Name</p>
              <input
                [formControl]="contextualListName"
                pInputText
                class="pb-2"
              />
              <p-button
                [disabled]="
                  !contextualListId.value || !contextualListName.value
                "
                class="py-3"
                label="Add"
                (click)="addContextualList()"
              >
              </p-button>
              <div
                class="flex p-3 border-1 col-10"
                [style.min-height]="'50px'"
                [style.min-width]="'500px'"
                [style.border-radius]="'5px'"
              >
                <ng-container *ngFor="let chip of contextualChips">
                  <p-chip
                    [removable]="true"
                    (onRemove)="removeContextualList(chip, config)"
                  >
                    {{ chip.name }}
                  </p-chip>
                </ng-container>
              </div>
              <p
                class="pt-2"
                [style.color]="'var(--primary-color)'"
                [style.cursor]="'pointer'"
                (click)="removeAllContextualLists()"
              >
                Remove All
              </p>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="flex justify-content-end">
        <p-button
          [disabled]="
            config.configKind.type === 'MAP'
              ? !contextualListChanged
              : config.fc.pristine
          "
          styleClass="p-2"
          label="Save Changes"
          (click)="setConfig(config)"
        ></p-button>
      </div>
    </div>
  </p-panel>
</ng-container>

<p-toast position="top-center"></p-toast>
}
